import { ResumeData } from '../../components/resume/resume-page'
import profileImage from '../profile.jpg'

export const resume: Pick<ResumeData, 'introduction' | 'contacts'> = {
  introduction: {
    name: 'Sascha Eisenmann',
    jobTitle: 'Software Engineer / Architekt',
    description:
      'Erfahrener Softwareentwickler und -Architekt mit einer Leidenschaft für Geschäftsprozesse und pragmatische technische Lösungen. Ich verbinde fundiertes Backend- und Frontend-Know-how mit einer DevOps-Denkweise, um Lösungen zu finden, die dein Unternehmen tatsächlich weiterbringen.',
    imageSrc: profileImage,
  },
  contacts: {
    email: 'consulting@eisenmann.it',
    phone: '+49 162 3092194',
  },
}
